import createCtx from 'coreUtils/createCtx';

export const [useScrollRestoration, ScrollRestorationProvider] = createCtx<{
	clearCurrentLocation: () => void;
	setOnRestoration: (cb: (() => void) | null) => void;
	getSavedScrollHeight: () => number;
	routeChanged: boolean;
}>();
